import { Route } from 'react-router'
import { ROUTES } from '../../constants/routes/routes-hycs'
import { AccountExistsPage } from '../generic/account-exists'
import { DeviceNotSupportedPage } from '../generic/device-not-supported'
import { ErrorPage } from '../generic/error'
import { LinkExpiredPage } from '../generic/link-expired'
import { TechnicalIssuesPage } from '../generic/technical-issues'
import { UnderReviewPage } from '../generic/under-review'
import { DisclosuresPage } from './disclosures'
import { DocumentVerificationPage } from './document-verification'
import { DocumentVerificationCompletePage } from './document-verification-complete'
import { EmploymentPage } from './employment'
import { EnterPhonePage } from './enter-phone'
import { FinancesPage } from './finances'
import { FundAccountPage } from './fund-account'
import { FundSuccessPage } from './fund-success'
import { GetStartedPage } from './get-started'
import { HomePage } from './home'
import { HomeAddressPage } from './home-address'
import { PersonalInfoPage } from './personal-info'
import { SecureAccountPage } from './secure-account'
import { SettingUpPage } from './setting-up'
import { VerifyEmailPage } from './verify-email'
import { VerifyIdentityPage } from './verify-identity'
import { VerifyPhonePage } from './verify-phone'
import { WelcomePage } from './welcome'
import { ManualReviewPage } from './manual-review'
//INTEGRATION:EnrolmentImports

export const routerHYCS = (): JSX.Element | null => {
  return (
    <>
      {/* INTEGRATION:EnrollmentRoute */}
      <Route path={ROUTES.MANUAL_REVIEW.path} element={<ManualReviewPage />} />
      <Route path={ROUTES.HYCS_HOME.path} element={<HomePage />} />
      <Route path={ROUTES.DOCUMENT_VERIFICATION_COMPLETE.path} element={<DocumentVerificationCompletePage />} />
      <Route path={ROUTES.DOCUMENT_VERIFICATION.path} element={<DocumentVerificationPage />} />
      <Route path={ROUTES.UNDER_REVIEW.path} element={<UnderReviewPage />} />
      <Route path={ROUTES.LINK_EXPIRED.path} element={<LinkExpiredPage />} />
      <Route path={ROUTES.DEVICE_NOT_SUPPORTED.path} element={<DeviceNotSupportedPage />} />
      <Route path={ROUTES.TECHNICAL_ISSUES.path} element={<TechnicalIssuesPage />} />
      <Route path={ROUTES.ACCOUNT_EXISTS.path} element={<AccountExistsPage />} />
      <Route path={ROUTES.ERROR.path} element={<ErrorPage />} />
      <Route path={ROUTES.FUND_SUCCESS.path} element={<FundSuccessPage />} />
      <Route path={ROUTES.DISCLOSURES.path} element={<DisclosuresPage />} />
      <Route path={ROUTES.VERIFY_PHONE.path} element={<VerifyPhonePage />} />
      <Route path={ROUTES.VERIFY_EMAIL.path} element={<VerifyEmailPage />} />
      <Route path={ROUTES.SETTING_UP.path} element={<SettingUpPage />} />
      <Route path={ROUTES.PERSONAL_INFO.path} element={<PersonalInfoPage />} />
      <Route path={ROUTES.HOME_ADDRESS.path} element={<HomeAddressPage />} />
      <Route path={ROUTES.FINANCES.path} element={<FinancesPage />} />
      <Route path={ROUTES.EMPLOYMENT.path} element={<EmploymentPage />} />
      <Route path={ROUTES.FUND_ACCOUNT.path} element={<FundAccountPage />} />
      <Route path={ROUTES.VERIFY_IDENTITY.path} element={<VerifyIdentityPage />} />
      <Route path={ROUTES.SECURE_ACCOUNT.path} element={<SecureAccountPage />} />
      <Route path={ROUTES.ENTER_PHONE.path} element={<EnterPhonePage />} />
      <Route path={ROUTES.WELCOME.path} element={<WelcomePage />} />
      <Route path={ROUTES.HYCS_GET_STARTED.path} element={<GetStartedPage />} />
    </>
  )
}
